export enum UserAction {
  ADD_USERS = "addUsers",
  REMOVE_USERS = "removeUsers",
  ADD_TO_EXCEPTION = "addToException",
  ADD_ALL_USERS = "addAllUsers",
  ADD_ALL_USERS_CONFIRMATION = "addAllUsersConfirmation",
  ADD_USERS_TO_PROTECTION_FROM_REPORT = "addUsersToProtectionFromReport",
  IMPORT_USERS_FROM_CSV = "importUsersFromCsv",
  DOWNLOAD_USERS_EXAMPLE_CSV = "downloadUsersExampleCsv",
  REMOVE_EXCEPTION = "removeException",
  ADD_USER_TO_PROTECTION = "addUserToProtection",
  REMOVE_USER_FROM_PROTECTION = "removeUserFromProtection",
  ADD_CLOUD_PROTECTION = "addCloudProtection",
  REMOVE_CLOUD_PROTECTION = "removeCloudProtection",
  ADD_AS_INDIVIDUAL = "addAsIndividual",
}

export enum UserGroupAction {
  ADD_NEW_GROUP = "addNewGroup",
  REMOVE_GROUPS = "removeGroups",
  DISABLE_GROUP_PROTECTION = "disableGroupProtection",
  ENABLE_GROUP_PROTECTION = "enableGroupProtection",
  PROTECT_GROUP = "protectGroup",
  UNPROTECT_GROUP = "unprotectGroup",
}

export enum GroupProtectionStatus {
  PROTECTED = "protected",
  UNPROTECTED = "unprotected",
  PARTIALLY_PROTECTED = "partiallyProtected",
}

export enum UserProtectionStatus {
  PROTECTED = "protected",
  UNPROTECTED = "unprotected",
}

export enum ExceptionsAction {
  ADD_NEW_EXCEPTION = "addNewException",
  REMOVE_EXCEPTION = "removeException",
}

export enum UserLabelsAction {
  CREATE_USER_LABEL = "createUserLabel",
  EDIT_USER_LABEL = "editUserLabel",
  DELETE_USER_LABEL = "deleteUserLabel",
  UNABLE_TO_DELETE_USER_LABEL = "unableToDeleteUserLabel",
}

export enum ProtectedUsersAction {
  MARK_AS_PROCESSED = "markAsProcessed",
  SIGN_IN_TO_ALL = "signInToAll",
  SIGN_IN_TO_SERVICE = "signInToService",
  ADD_LABEL = "addLabel",
  REMOVE_LABEL = "removeLabel",
  RESET_CLIENT_MFA = "resetClientMfa",
}
export enum UsersSuspendedFilterItem {
  SUSPENDED = "suspended",
  ACTIVE = "active",
}

export enum UsersMfaFiltersItem {
  MFA_ENABLED = "mfaEnabled",
  MFA_DISABLED = "mfaDisabled",
}

export enum UsersAutoForwardingFiltersItem {
  AUTO_FORWARDING_BLOCKING_ENABLED = "autoForwardingBlockingEnabled",
  AUTO_FORWARDING_BLOCKING_DISABLED = "autoForwardingBlockingDisabled",
}

export enum UserManualDecision {
  PROTECTED = "PROTECTED",
  EXCLUDED = "EXCLUDED",
}
